var _rect, _text, _text2, _rect2, _circle, _text3, _rect3, _rect4, _text4, _text5, _text6, _rect5, _text7, _rect6, _text8, _text9, _text0, _rect7, _text1, _rect8, _text10, _rect9, _text11, _rect0, _text12, _text13, _text14, _rect1, _rect10, _path, _text15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalentlenzAssessmentBuilderInterface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 760,
    height: 390,
    viewBox: "0 0 760 390",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TalentLenz assessment builder interface") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 758,
    height: 388,
    rx: 24,
    fill: "#FFFFFF",
    stroke: "#C9DCF2",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 45,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 800
  }, "Assessment builder")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 68,
    fill: "#627690",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11.5
  }, "Senior Mine Planner \xB7 Opportunity-specific assessment")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 566,
    y: 27,
    width: 164,
    height: 34,
    rx: 17,
    fill: "#EAF4FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 586,
    cy: 44,
    r: 5,
    fill: "#087CFF"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 48,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 780
  }, "DRAFT \xB7 HR REVIEW")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 96,
    width: 704,
    height: 58,
    rx: 15,
    fill: "#F7FAFE",
    stroke: "#D9E4F3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 106,
    width: 176,
    height: 38,
    rx: 12,
    fill: "#087CFF"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 126,
    y: 130,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12.5,
    fontWeight: 760
  }, "AI generate")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 294,
    y: 130,
    fill: "#50647F",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12.5,
    fontWeight: 700
  }, "Upload existing")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 451,
    y: 130,
    fill: "#50647F",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12.5,
    fontWeight: 700
  }, "Hybrid")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 113,
    width: 104,
    height: 24,
    rx: 12,
    fill: "#FFF1F6"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 652,
    y: 129,
    fill: "#FF3885",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5,
    fontWeight: 760
  }, "12 SUGGESTIONS")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 175,
    width: 450,
    height: 174,
    rx: 18,
    fill: "#FFFFFF",
    stroke: "#D9E4F3"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 205,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5,
    fontWeight: 800,
    letterSpacing: 1.2
  }, "QUESTION 04 \xB7 TECHNICAL COMPETENCY")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 238,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15.5,
    fontWeight: 720
  }, "Which evidence best confirms that the")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 260,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15.5,
    fontWeight: 720
  }, "production plan is operationally viable?")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 285,
    width: 126,
    height: 32,
    rx: 10,
    fill: "#EAF4FF"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 113,
    y: 306,
    fill: "#087CFF",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5,
    fontWeight: 740
  }, "MULTIPLE CHOICE")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 285,
    width: 98,
    height: 32,
    rx: 10,
    fill: "#F7FAFE",
    stroke: "#D9E4F3"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 239,
    y: 306,
    fill: "#50647F",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5,
    fontWeight: 700
  }, "2 MINUTES")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 285,
    width: 146,
    height: 32,
    rx: 10,
    fill: "#FFF1F6"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 379,
    y: 306,
    fill: "#FF3885",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5,
    fontWeight: 740
  }, "AI SUGGESTED")), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 498,
    y: 175,
    width: 234,
    height: 174,
    rx: 18,
    fill: "#07152A"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 205,
    fill: "#80C4FF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5,
    fontWeight: 800,
    letterSpacing: 1.2
  }, "REVIEW STATUS")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 244,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 31,
    fontWeight: 820
  }, "10 / 12")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 267,
    fill: "#C1CDDC",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12
  }, "questions approved by HR")), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 291,
    width: 184,
    height: 10,
    rx: 5,
    fill: "#143356"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 291,
    width: 153,
    height: 10,
    rx: 5,
    fill: "#087CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m520 323 4 4 8-9",
    fill: "none",
    stroke: "#FF85B2",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 543,
    y: 329,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11.5,
    fontWeight: 700
  }, "Human review required")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentlenzAssessmentBuilderInterface);
export default __webpack_public_path__ + "static/media/talentlenz-assessment-builder-interface.fc0e755b69963b10aa64cb8f5baf1e43.svg";
export { ForwardRef as ReactComponent };